import React from "react";
import MaskedInput from "react-text-mask";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";
import { cn } from "../../../utils/cn";
import {
  MASKED_DATE_INPUT_MASK,
  MASKED_DATE_PLACEHOLDER,
} from "../utils/maskedDate";

const datePipe = createAutoCorrectedDatePipe("dd/mm/yyyy");

interface MaskedDateInputProps {
  id?: string;
  value: string;
  onChange: (value: string) => void;
  className?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
}

export default function MaskedDateInput({
  id,
  value,
  onChange,
  className,
  placeholder = MASKED_DATE_PLACEHOLDER,
  required = false,
  disabled = false,
}: MaskedDateInputProps) {
  return (
    <MaskedInput
      id={id}
      mask={[...MASKED_DATE_INPUT_MASK]}
      pipe={datePipe}
      guide
      keepCharPositions
      placeholder={placeholder}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      disabled={disabled}
      render={(ref, inputProps) => (
        <input
          ref={ref as React.Ref<HTMLInputElement>}
          {...inputProps}
          type="text"
          inputMode="numeric"
          autoComplete="off"
          required={required}
          className={cn(
            "rounded-xl border border-white/[0.08] bg-[#0d1117] px-3 py-2.5 text-sm text-[#f0f6fc] outline-none focus:border-[#6ea8ff]/50 disabled:cursor-not-allowed disabled:opacity-50",
            className
          )}
        />
      )}
    />
  );
}
